// Regex patterns + label maps used to detect a visitor's first name and role
// from natural-language chat input.

export const NAME_STORAGE_KEY = "rtc_visitor_name";
export const ROLE_STORAGE_KEY = "rtc_visitor_role";

// Match phrases like "my name is Sarah", "I'm Marcus", "this is John", "call me Jay".
const NAME_RE = /(?:my\s+name\s+is|i(?:'|’)?m|i\s+am|this\s+is|call\s+me)\s+([A-Za-z][A-Za-z'’-]{1,29})/i;

const NAME_BLOCKLIST = new Set([
    "looking", "wondering", "asking", "trying", "calling", "interested",
    "hoping", "thinking", "checking", "writing", "from", "here", "good",
    "fine", "okay", "ok", "great", "sorry", "tired", "back",
]);

export function extractName(text) {
    const m = NAME_RE.exec(text);
    if (!m) return null;
    const raw = m[1].trim();
    if (NAME_BLOCKLIST.has(raw.toLowerCase())) return null;
    return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
}

// Order matters — more specific phrases come first.
const ROLE_PATTERNS = [
    [/foster\s+(?:parent|mom|mother|dad|father)/i, "foster_parent"],
    [/case[\s-]?(?:worker|manager)/i, "caseworker"],
    [/social\s+worker/i, "social_worker"],
    [/(?:high\s+school|middle\s+school|school)\s+(?:teacher|administrator|principal)/i, "school_staff"],
    [/(?:school\s+)?counselor/i, "counselor"],
    [/(?:teacher|principal|administrator)/i, "school_staff"],
    [/probation\s+officer/i, "juvenile_justice"],
    [/juvenile\s+(?:justice|probation)/i, "juvenile_justice"],
    [/(?:pastor|minister|youth\s+pastor)/i, "faith_leader"],
    [/church/i, "faith_leader"],
    [/(?:guardian|grandparent|grandma|grandmother|grandpa|grandfather|aunt|uncle)/i, "guardian"],
    [/(?:mom|mother|dad|father|parent)/i, "parent"],
    [/(?:youth|teen|teenager|kid|young\s+man)/i, "self"],
];

const SELF_ID_RE = /(?:i(?:'|’)?m|i\s+am|i\s+work\s+as|i\s+am\s+a|i'm\s+a|im\s+a|as\s+a)/i;

export function extractRole(text) {
    if (!SELF_ID_RE.test(text)) return null;
    for (const [re, role] of ROLE_PATTERNS) {
        if (re.test(text)) return role;
    }
    return null;
}

export const ROLE_LABEL = {
    parent: "parent",
    guardian: "guardian",
    foster_parent: "foster parent",
    caseworker: "caseworker",
    social_worker: "social worker",
    counselor: "school counselor",
    school_staff: "educator",
    juvenile_justice: "juvenile justice partner",
    faith_leader: "faith/community partner",
    self: "young person",
};
